<template>
  <div>
    <div class="form-container oudonation ou-donation-form ncsysummer-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Select Your Gift Amount">
            <div>
              <AmountSelectorSummer />
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly monthesSelector/>
            </div>
          </FormSection>
          <FormSection title="Designation">
            <FormRow inline>
              <FormCol field="custom.designation" width="half" :showLabel="false">
                <FormSelect>
                  <option selected="selected" value="SummerCamp">
                    Select a Designation
                  </option>
                  <option value="Camp Kesher">Camp Kesher</option>
                  <option value="Camp Sports Scholarship">Camp Sports</option>
                  <option value="NCSY Chai">Chai</option>
                  <option value="Impact">Impact</option>
                  <option value="Jumpshot">Jumpshot</option>
                  <option value="Kollel Scholarship">Kollel</option>
                  <option value="Kollel Mechina">Kollel Mechina</option>
                  <option value="Euro 4G">Euro 4G</option>
                  <option value="GIVE Scholarship">GIVE</option>
                  <option value="GIVE West">GIVE West</option>
                  <option value="LEAD">LEAD</option>
                  <option value="Michlelet Scholarship">Michlelet</option>
                  <option value="Michlelet Mechina">Michlelet Mechina</option>
                  <option value="Euro Israel">Euro Israel</option>
                  <option value="Hatzalah Rescue Israel">Hatzalah Rescue</option>
                  <option value="Israel ID Scholarship">Israel ID</option>
                  <option value="JOLT Israel Scholarship">JOLT Israel</option>
                  <option value="Justifi Thailand">Justifi Thailand</option>
                  <option value="Kadima Lavi">Kadima</option>
                  <option value="Next Step Israel">Next Step Israel Internships</option>
                  <option value="Relief">NCSY Chessed Relief Missions</option>
                  <option value="TJJ Donation">TJJ</option>
                  <option value="TJJ AP Scholarship">TJJ AP</option>
                  <option value="TJJ Action">TJJ Action</option>
                  <option value="TJJ Sephardic">TJJ Sephardic</option>
                  <option value="Yeshivat TJJ">Yeshivat TJJ</option>
                  <option value="JSU GO">JSU GO</option>
                  <option value="General Scholarship Donation">
                    General Scholarship Fund
                  </option>
                </FormSelect>
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Your Contact Information">
            <FormRow inline>
              <FormCol :simpleTitle="true" field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
            <br />
            <InHonorOf />
            <br />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Info" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  components: {},
  setup(props) {
    const { getValue, settings, setValue, form } = usePaymentForm();

    watch(() => getValue('custom.designation'), (val) => {
        if (val == "Relief" || !val) {
          setValue("applications.0.department", "NCSY_ReliefMissions");
          setValue("applications.0.campaign", "General Donation");
        } else {
          setValue("applications.0.department", "NCSY_Summer");
          setValue("applications.0.campaign", val);
        }
      }
    );

    return {
      form,
      getValue,
      settings,
      setValue,
    };
  },
});
</script>

<style scoped lang="scss">
::v-deep h2 {
  margin-bottom: 10px;
  margin-top: 20px;
  color: #000;
  font-weight: 700;
  font-size: 1.25em;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.donate-intro {
  font-size: 18px;
  line-height: 26px;
  color: #00346b;
  p {
    margin-bottom: 10px;
  }
  a {
    color: #00346b;
    font-weight: 600;
  }
}

.form-container.ou-donation-form.ncsysummer-donation-form {
  max-width: 100%;
  overflow: hidden;
  box-shadow: none;
  padding: 0px;
  @media only screen and (min-width: 720px) {
    padding: 0px 0px;
    margin: 0px auto;
    max-width: 840px;
  }
}
// .ncsysummer-donation-form
//   ::v-deep
//   .styled-radio-container--ou-donation.styled-radio-container {
//   justify-content: center;

//   label {
//     border: 1px solid #0d346c;
//     color: #000000;
//     font-size: 15px;
//     &:hover {
//       background: #f7f7f7;
//     }
//   }
//   input[type="radio"]:checked + label {
//     background: #0d346c;
//   }
//   input[type="radio"]:checked + label .label-amount {
//     background: #0d346c;
//     border-color: #0d346c;
//   }
//   .label-description {
//     font-size: 16px;
//   }
//   .label-amount {
//     background: #0d346c;
//     color: white;
//   }
//   .radio-part {
//     min-width: 50%;
//     line-height: 20px;
//     max-width: 50%;
//   }
// }

.footer-links {
  text-align: center;
  font-size: 16px;
  margin: 50px auto 28px;
  line-height: 26px;
  color: #00346b;
  a {
    text-decoration: none;
  }
}
.footer-copyright {
  line-height: 15px;
  text-align: center;
  font-size: 12px;
  color: #222;
  font-style: italic;
}

.payment {
  margin: 20px auto 20px;
  ::v-deep .ou-donation-btn {
    width: 300px;
    max-width: 100%;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
}

.frequency {
  margin-top: 20px;
}
// .teach-donation-form .payment-info ::v-deep .styled-radio-container--ou-donation{
// 		.radio-part{
// 	  @media only screen and (min-width: 720px) {
// 			min-width: 50%;
// 			max-width: 50%;
// 		}
// 		}
// }

label {
  line-height: normal;
}
.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}

.doublepay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ncsysummer-donation-form ::v-deep .styled-radio--ou-donation.styled-radio label {
  font-size: 16px;
}
.ncsysummer-donation-form
  ::v-deep
  .styled-radio--ou-donation
  .amount_other__wrapper
  input[type="number"] {
  font-size: 16px;
}

.ncsysummer-donation-form
  ::v-deep
  .payment-info
  .styled-radio-container--ou-donation.styled-radio-container
  .radio-part {
  min-width: 50%;
  max-width: 50%;
}

::v-deep h2 {
  margin-bottom: 10px;
  margin-top: 20px;
  font-size: 20px;
  color: black;
}
</style>
